
<template>
  <v-container fill-height>
    <v-container fill-height v-if="step===1">
      <v-row no-gutters justify="center">
        <v-col cols="12" md="8" align="center">
          <span class="title">Confirm you need help with...</span>

        </v-col>

      </v-row>
      <v-row no-gutters>
        <v-col cols="12">

          <v-row no-gutters justify="center">
            <v-col cols="6" md="2" align="center">
              <v-img contain height="150" width="150" :src="require(`@/assets/${$route.query.type}.svg`)" :alt="null"></v-img>
            </v-col>
            <v-col cols="12" align="center">
              {{$route.query.type}}
            </v-col>

          </v-row>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" align="center">
          <v-btn width="250px" large color="primary" @click="()=>{step=null;logStep(1)}">Next</v-btn>
        </v-col>
      </v-row>

      <v-row no-gutters justify="center" @click="openCat=true">
        Need help with something else?
      </v-row>
      <v-row no-gutters>
        <v-col cols="12">

        </v-col>
      </v-row>

    </v-container>
    <v-container fill-height v-else>
      <v-row no-gutters justify="center">
        <v-col cols="12" md="8" align="center">
          <v-row justify="center">
            <span class="title">Awesome, let's use one of your social accounts to setup your profile.</span>
          </v-row>

        </v-col>
      </v-row>

      <v-row no-gutters justify="center">
        <v-col cols="12">
          <v-row justify="center">
            <v-btn large :style="`width: ${ $vuetify.breakpoint.xs ? '90%' : $vuetify.breakpoint.sm ? '60%' : '30%' }`" class="text-none grey--text text--darken-3 mb-4" color="white" @click="loginGoogle">
              <v-row no-gutters justify="center" align="center">
                <v-col cols="1">
                  <v-icon color="#DB4437">fab fa-google</v-icon>
                </v-col>
                <v-col cols="8" class="pl-4" align="start">
                  <div>{{ $language.login['Sign in with Google'] }}</div>
                </v-col>
              </v-row>
            </v-btn>
          </v-row>
        </v-col>
        <v-col cols="12">
          <v-row justify="center">
            <v-btn large :style="`width: ${ $vuetify.breakpoint.xs ? '90%' : $vuetify.breakpoint.sm ? '60%' : '30%' }`" class="text-none grey--text text--darken-3 mb-4" color="white" @click="loginFacebook">
              <v-row no-gutters justify="center" align="center">
                <v-col cols="1">
                  <v-icon color="#3b5998">fab fa-facebook</v-icon>
                </v-col>
                <v-col cols="8" class="pl-4" align="start">
                  <div>{{ $language.login['Sign in with Facebook'] }}</div>
                </v-col>
              </v-row>
            </v-btn>
          </v-row>
        </v-col>
      </v-row>
      <v-row no-gutters justify="center">
        <v-col cols="12" >
        </v-col>
      </v-row>

    </v-container>
    <v-dialog v-model="openCat" scrollable persistent :overlay="false" max-width="500px" transition="dialog-transition">

      <v-card style="overflow-y:auto; overflow-x:hidden">
        <v-toolbar color="transparent" flat tile>
          <div class="title  font-weight-bold">
            What are you looking for?
          </div>
          <v-spacer></v-spacer>
          <v-app-bar-nav-icon @click="openCat = false" color="primary">
            <v-icon>close</v-icon>
          </v-app-bar-nav-icon>
        </v-toolbar>
        <v-row class="px-4">
          <v-col cols="4" v-for="(cat,index) in categories" :key="index">
            <v-card @click="selectCat(cat._key)">
              <v-row no-gutters>
                <v-col cols="12" align="center">
                  <v-img :src="require(`@/assets/${cat._key}.svg`)" :alt="null"></v-img>
                </v-col>
                <v-col cols="12" align="center">
                  <span class="caption">{{cat._key}}</span>
                </v-col>
              </v-row>
            </v-card>
          </v-col>
        </v-row>

      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import {
  mapState
} from 'vuex'
import moment from 'moment'
const fb = require('@/services/firebaseConfig.js')
export default {
  components: {
  },
  data () {
    return {
      openCat: false,
      step: 1
    }
  },

  mounted () {
    // console.log(this.$route.query)
    // console.log(fb.auth.currentUser)
    // if (fb.auth.currentUser !== null && !this.userProfile.firstEntry) {
    //   this.$router.push('/dashboard')
    // }
    this.$store.dispatch('fetchCategories')
  },

  computed: {
    ...mapState(['categories', 'currentUser', 'userProfile'])
  },

  methods: {
    logStep (step) {
      fb.analytics.logEvent(`hefe_campaign_step_${step}`)
    },
    selectCat (key) {
      this.$router.push({ path: '/public/campaign', query: { type: key, hefeCamp: true, step: 2 } })
      this.openCat = false
    },
    loginFacebook () {
      this.performingRequest = true
      var provider = new fb.firebase.auth.FacebookAuthProvider()
      fb.auth.signInWithRedirect(provider).then(user => {
        this.performingRequest = false
      }).catch(err => {
        console.log(err)
        this.performingRequest = false
        this.errorMsg = err.message
      })
    },
    loginGoogle () {
      this.performingRequest = true
      this.$router.push({ path: '/public/campaign', query: { type: this.$route.query.type, hefeCamp: true, step: 2 } })
      var provider = new fb.firebase.auth.GoogleAuthProvider()
      provider.setCustomParameters({
        prompt: 'select_account'
      })
      fb.auth.signInWithRedirect(provider).then(user => {
        this.performingRequest = false
      }).catch(err => {
        this.performingRequest = false
        this.errorMsg = err.message
      })
    }
  },
  watch: {

  },
  filters: {
    formatDate (val) {
      if (!val) {
        return '-'
      }
      let date = val.toDate()
      return moment(date).fromNow()
    },
    formatDateTime (val) {
      if (!val) {
        return '-'
      }
      let date = new Date(val)
      return moment(date).fromNow()
    },
    trimLength (val) {
      return `${val.substring(0, 8)}...`
    },
    formatDist (val) {
      return val + ' mi.'
    },

    formatTime (val) {
      if (!val) {
        return '-'
      }
      return moment(val, ['HH.mm']).format('hh:mm a')
    }
  }
}
</script>
